import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/_Symbol.js
// module id = 84
// module chunks = 0 1